import { CoreIcon } from '../core-icon';
import logoutSVG from '../../assets/icons/logout.svg';
import type { IconProps } from '../core-icon';

export const LogoutIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={logoutSVG} {...props} />;
};
